import React, { useState, useEffect, useMemo } from "react";
import {
  Typography,
  Divider,
  Box,
  AppBar,
  Toolbar,
  Stepper,
  Step,
  StepLabel,
  CircularProgress,
} from "@material-ui/core";

import {
  getCaseStudyAPI,
  updateCaseStudyDetailsAPI,
  backgroundStepAPI,
  ideationStepAPI,
  researchStepAPI,
  generationStepAPI,
} from "views/APIs/CaseStudyUtility";
import { stepperStyles, QontoConnector } from "views/Styles/stepperStyles";
import ProjectDetails from "./ProjectDetails";
import appbarStyles from "views/Styles/appbarStyles";
import styles from "assets/jss/material-dashboard-pro-react/views/dashboardStyle.js";
import { makeStyles } from "@material-ui/core/styles";
import NotificationContext from "views/Components/Context.js";
import { Auth } from "aws-amplify";
import ReviewScreen from "../ReviewScreen";
import {
  AssignmentInd,
  Description,
  Details,
  Drafts,
  Edit,
  Note,
  Print,
  ViewAgenda,
} from "@material-ui/icons";
import Background from "./Background";
import Ideation from "./Ideation";
import { fetchAllProjectsAPI } from "views/APIs/ProjectsUtility";
import {
  saveBackgroundAPI,
  saveIdeationAPI,
  saveResearchAPI,
  draftStepAPI,
  saveDraftAPI,
} from "views/APIs/CaseStudyUtility";
import { convertToPdf } from "views/APIs/ToolboxUtility";
import { saveLabDetailsAPI } from "views/APIs/CaseStudyUtility";
import { saveTeachingNoteAPI } from "views/APIs/CaseStudyUtility";

const useStyles = makeStyles((theme) => ({
  ...styles,
  ...stepperStyles(theme),
  ...appbarStyles(theme),
}));

function getFileList(doc) {
  if (!doc || !Array.isArray(doc.uploaded_files)) return [];

  return doc.uploaded_files.map((file) => ({
    id: file.file_id,
    name: file.name,
  }));
}

export const CaseStudyBoard = (props) => {
  const classes = useStyles();
  const { showNotification } = React.useContext(NotificationContext);

  const [caseStudyDetails, setCaseStudyDetails] = useState({
    _id: "123123123",
    name: "AML SAR",
    description: "AML Case Study",
    timestamp: "2025-09-30T10:15:00.000Z",
    status: "In Design Phase",
    linked_project_id: "123123123",
    associated_project_id: "123123123",
    case_study_md: [
      {
        version: 1,
        markdown: "",
        timestamp: "2025-09-30T10:15:00.000Z",
      },
    ],
    uploaded_files: [],
    background: {
      case_subject: "",
      industry: "",
      context: "",
      primary_problem: "",
      target_audience: "",
      case_focus: "",
    },
    ideation: {
      ideas: [
        {
          name: "idea 1",
          description: "idea description 1",
        },
        {
          name: "idea 2",
          description: "idea description 2",
        },
        {
          name: "idea 3",
          description: "idea description 3",
        },
        {
          name: "idea 4",
          description: "idea description 4",
        },
        {
          name: "idea 5",
          description: "idea description 5",
        },
      ],
    },
    has_teaching_note: false,
    has_lab_details: false,
    selected_idea_index: 0,
    research: [
      {
        version: 1,
        markdown: "",
        timestamp: "2025-09-30T10:15:00.000Z",
      },
    ],
    draft: [
      {
        version: 1,
        markdown: "",
        timestamp: "2025-09-30T10:15:00.000Z",
      },
    ],
    teaching_note: [
      {
        version: 1,
        markdown: "",
        timestamp: "2025-09-30T10:15:00.000Z",
      },
    ],
    tags: [],
  });

  const [activeStep, setActiveStep] = useState(0);
  const [caseStudyCompletedTillStep, setCaseStudyCompletedTillStep] = useState(
    0
  );
  const [loader, setLoader] = useState({
    show: false,
    type: "",
    message: "",
  });
  const [researchMarkdown, setResearchMarkdown] = useState("");
  const [
    originalResearchMarkdownContent,
    setOriginalResearchMarkdownContent,
  ] = useState("");
  const [
    currentResearchMarkdownVersion,
    setCurrentResearchMarkdownVersion,
  ] = useState("");
  const [draftMarkdown, setDraftMarkdown] = useState("");
  const [
    originalDraftMarkdownContent,
    setOriginalDraftMarkdownContent,
  ] = useState("");
  const [
    currentDraftMarkdownVersion,
    setCurrentDraftMarkdownVersion,
  ] = useState("");
  const [teachingNoteMarkdown, setTeachingNoteMarkdown] = useState("");
  const [
    originalTeachingNoteMarkdownContent,
    setOriginalTeachingNoteMarkdownContent,
  ] = useState("");
  const [
    currentTeachingNoteMarkdownVersion,
    setCurrentTeachingNoteMarkdownVersion,
  ] = useState("");
  const [labDetailsMarkdown, setLabDetailsMarkdown] = useState("");
  const [
    originalLabDetailsMarkdownContent,
    setOriginalLabDetailsMarkdownContent,
  ] = useState("");
  const [
    currentLabDetailsMarkdownVersion,
    setCurrentLabDetailsMarkdownVersion,
  ] = useState("");
  const [fileList, setFileList] = useState([]);

  const caseStudySteps = [
    { label: "Details", icon: <Description />, lockedMessage: "" },
    {
      label: "Background",
      icon: <ViewAgenda />,
      lockedMessage:
        "Please review the project details to move on to the next step.",
    },
    {
      label: "Ideation",
      icon: <ViewAgenda />,
      lockedMessage: "Please review the markdown to move on to the next step.",
    },
    {
      label: "Research",
      icon: <Edit />,
      lockedMessage: "Please review the json to move on to the next step.",
    },
    {
      label: "Draft",
      icon: <Note />,
      lockedMessage: "",
    },
  ];

  const caseStudyStatusToLabelMapping = {
    Details: "Ideate Case",
    Background: "Provide Details",
    Ideation: "Generate Ideas",
    Research: "Curate Research",
    Draft: "Generate Case Study",
  };

  const statusToStepMapping = {
    Details: 0,
    Background: 1,
    Ideation: 2,
    Research: 3,
    Draft: 4,
  };

  const { caseStudyID } = props.match.params;
  const [user, setUser] = useState("");
  const [suppressContentOnly, setSuppressContentOnly] = useState(false);
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    const fetchCaseStudyDetails = async () => {
      if (!caseStudyID) return;
      setLoader({
        show: true,
        type: "fetch",
        message:
          "Fetching case study details. This might take a few seconds...",
      });
      const formData = new FormData();
      formData.append("case_study_id", caseStudyID);
      const caseStudyDetails = await getCaseStudyAPI(formData);
      setCaseStudyDetails(caseStudyDetails);
      setActiveStep(statusToStepMapping[caseStudyDetails.status]);
      setCaseStudyCompletedTillStep(
        statusToStepMapping[caseStudyDetails.status]
      );
      const latestResearchVersion =
        caseStudyDetails?.research?.length > 0
          ? caseStudyDetails?.research?.[caseStudyDetails?.research?.length - 1]
              ?.version
          : 1;
      setOriginalResearchMarkdownContent(
        caseStudyDetails?.research[latestResearchVersion - 1]?.markdown || ""
      );
      setResearchMarkdown(
        caseStudyDetails?.research[latestResearchVersion - 1]?.markdown || ""
      );
      setCurrentResearchMarkdownVersion(latestResearchVersion);
      const latestDraftVersion =
        caseStudyDetails?.draft?.length > 0
          ? caseStudyDetails?.draft?.[caseStudyDetails?.draft?.length - 1]
              ?.version
          : 1;
      setDraftMarkdown(
        caseStudyDetails?.draft[latestDraftVersion - 1]?.markdown || ""
      );
      setOriginalDraftMarkdownContent(
        caseStudyDetails?.draft[latestDraftVersion - 1]?.markdown || ""
      );
      setCurrentDraftMarkdownVersion(latestDraftVersion);

      const latestTeachingNoteVersion =
        caseStudyDetails?.teaching_note?.length > 0
          ? caseStudyDetails?.teaching_note?.[
              caseStudyDetails?.teaching_note?.length - 1
            ]?.version
          : 1;
      setTeachingNoteMarkdown(
        caseStudyDetails?.teaching_note[latestTeachingNoteVersion - 1]
          ?.markdown || ""
      );
      setOriginalTeachingNoteMarkdownContent(
        caseStudyDetails?.teaching_note[latestTeachingNoteVersion - 1]
          ?.markdown || ""
      );
      setCurrentTeachingNoteMarkdownVersion(latestTeachingNoteVersion);

      const latestLabDetailsVersion =
        caseStudyDetails?.lab_details?.length > 0
          ? caseStudyDetails?.lab_details?.[
              caseStudyDetails?.lab_details?.length - 1
            ]?.version
          : 1;
      setLabDetailsMarkdown(
        caseStudyDetails?.lab_details[latestLabDetailsVersion - 1]?.markdown ||
          ""
      );
      setOriginalLabDetailsMarkdownContent(
        caseStudyDetails?.lab_details[latestLabDetailsVersion - 1]?.markdown ||
          ""
      );
      setCurrentLabDetailsMarkdownVersion(latestLabDetailsVersion);

      setLoader({ show: false, type: "", message: "" });
      setFileList(getFileList(caseStudyDetails));
      const projects = await fetchAllProjectsAPI();
      setProjects(
        projects.map((project) => ({
          name: project.name,
          id: project._id,
        }))
      );
    };
    fetchCaseStudyDetails();
  }, [caseStudyID]);

  useEffect(() => {
    if (activeStep > caseStudyCompletedTillStep) {
      setCaseStudyCompletedTillStep(activeStep);
    }
  }, [activeStep]);

  // In-between loader messages (LOCAL)
  const inBetweenStagesLoaderOptions = {};
  // Derived flags
  const isInBetween = useMemo(
    () =>
      Object.prototype.hasOwnProperty.call(
        inBetweenStagesLoaderOptions,
        caseStudyDetails.status
      ),
    [caseStudyDetails.status]
  );

  // Big expected-time line
  const WAIT_MSG = useMemo(() => {
    if (!isInBetween) return "";
    const min = 10 + Math.floor(Math.random() * 5);
    const max = 15 + Math.floor(Math.random() * 6);
    return `Expected time: ${min}-${max} minutes. You can leave this tab; processing will continue in the background.`;
  }, [isInBetween]);

  // Step index from current status (base)
  const baseStepIndex = useMemo(() => {
    const raw = statusToStepMapping[caseStudyDetails.status];
    return Number.isInteger(raw) ? raw : statusToStepMapping.default;
  }, [caseStudyDetails.status, statusToStepMapping]);

  // Stepper behavior
  const stepperInBetween = isInBetween; // stepper always shows loading when in-between
  const contentInBetween = isInBetween && !suppressContentOnly; // content can hide loader after back nav

  // Visual step for the Stepper (pin to loading bubble if in-between)
  const visualActiveStep = useMemo(
    () => (stepperInBetween ? baseStepIndex + 1 : activeStep),
    [stepperInBetween, baseStepIndex, activeStep]
  );

  const handleStepClick = (uiIndex) => {
    const isIntermediate = stepperInBetween && uiIndex === baseStepIndex + 1;

    if (isIntermediate) {
      // Clicking the loading bubble restores the content loader
      setSuppressContentOnly(false);
      return;
    }

    // Map UI index to real content index (skip the inserted loading bubble)
    const realIndex =
      stepperInBetween && uiIndex > baseStepIndex ? uiIndex - 1 : uiIndex;

    // ✅ Allow any step up to what’s completed
    const canAccess = realIndex <= caseStudyCompletedTillStep;
    if (!canAccess) {
      const message =
        caseStudySteps[realIndex]?.lockedMessage || "This step is locked.";
      showNotification(message, "danger");
      return;
    }

    // If loading and user is going to a previous/at step, hide only the content loader
    if (isInBetween && realIndex <= baseStepIndex) {
      setSuppressContentOnly(true);
    }

    setActiveStep(realIndex);
  };

  // Build steps with an inserted Loading… pseudo-step
  const stepsWithIntermediate = useMemo(() => {
    if (!stepperInBetween) return caseStudySteps;
    const insertAt = baseStepIndex + 1;
    const loadingStep = {
      label: "Loading…",
      isIntermediate: true,
      lockedMessage: "",
    };
    return [
      ...caseStudySteps.slice(0, insertAt),
      loadingStep,
      ...caseStudySteps.slice(insertAt),
    ];
  }, [stepperInBetween, baseStepIndex, caseStudySteps]);

  const onDetailsSave = async (caseStudyDetails) => {
    setLoader({
      show: true,
      type: "save",
      message: "Saving case study details. This might take a few seconds...",
    });
    setCaseStudyDetails(caseStudyDetails);

    const formData = new FormData();
    formData.append("case_study_id", caseStudyID);
    formData.append("name", caseStudyDetails.name);
    formData.append("description", caseStudyDetails.description);
    formData.append(
      "associated_project_id",
      caseStudyDetails.associated_project_id
    );
    formData.append("has_teaching_note", caseStudyDetails.has_teaching_note);
    formData.append("has_lab_details", caseStudyDetails.has_lab_details);

    if (caseStudyDetails.linked_project_id) {
      formData.append("linked_project_id", caseStudyDetails.linked_project_id);
    }
    await updateCaseStudyDetailsAPI(formData);
    setLoader({ show: false, type: "", message: "" });
    showNotification("Case study details saved successfully", "success");
  };

  const onDetailsNext = async (caseStudyDetails) => {
    await onDetailsSave(caseStudyDetails);

    try {
      setLoader({
        show: true,
        type: "save",
        message: "Extracting details for the case study...",
      });
      const formData = new FormData();
      formData.append("case_study_id", caseStudyID);
      const response = await backgroundStepAPI(formData);
      setCaseStudyDetails(response);
      showNotification("Case study background created successfully", "success");
      setActiveStep(activeStep + 1);
    } catch (error) {
      console.log(error);
      showNotification("Case study background creation failed", "danger");
    } finally {
      setLoader({ show: false, type: "", message: "" });
    }
  };

  const onBackgroundSave = async () => {
    try {
      setLoader({
        show: true,
        type: "save",
        message: "Saving background details...",
      });
      const formData = new FormData();
      formData.append("case_study_id", caseStudyID);
      formData.append(
        "background",
        JSON.stringify(caseStudyDetails.background)
      );
      const response = await saveBackgroundAPI(formData);
      setCaseStudyDetails(response);
      showNotification("Background saved successfully", "success");
    } catch (error) {
      console.log(error);
      showNotification("Background saving failed", "danger");
    } finally {
      setLoader({ show: false, type: "", message: "" });
    }
  };

  const onBackgroundNext = async () => {
    await onBackgroundSave();
    try {
      setLoader({
        show: true,
        type: "save",
        message:
          "Generating ideas for your case study. This might take a few seconds...",
      });
      const formData = new FormData();
      formData.append("case_study_id", caseStudyID);
      const response = await ideationStepAPI(formData);
      setCaseStudyDetails(response);
      showNotification("Ideas generated successfully", "success");
      setActiveStep(activeStep + 1);
    } catch (error) {
      console.log(error);
      showNotification("Ideas generation failed", "danger");
    } finally {
      setLoader({ show: false, type: "", message: "" });
    }
  };

  const onIdeationSave = async (payload) => {
    try {
      setLoader({ show: true, type: "save", message: "Saving your ideas..." });
      const formData = new FormData();
      formData.append("case_study_id", caseStudyID);
      formData.append("ideation", JSON.stringify(payload.ideation));
      formData.append("selected_idea_index", payload.selected_idea_index);
      const response = await saveIdeationAPI(formData);
      setCaseStudyDetails(response);
      showNotification("Ideas saved successfully", "success");
    } catch (error) {
      console.log(error);
      showNotification("Case study ideation saving failed", "danger");
    } finally {
      setLoader({ show: false, type: "", message: "" });
    }
  };

  const onIdeationNext = async (payload) => {
    await onIdeationSave(payload);
    try {
      setLoader({
        show: true,
        type: "save",
        message:
          "Researching the web for your case study. This might take a few seconds...",
      });
      const formData = new FormData();
      formData.append("case_study_id", caseStudyID);
      const response = await researchStepAPI(formData);
      setCaseStudyDetails(response);
      const latestResearchVersion =
        response?.research?.length > 0
          ? response?.research?.[response?.research?.length - 1]?.["version"]
          : 1;
      setResearchMarkdown(
        response?.research?.[latestResearchVersion - 1]?.["markdown"]
      );
      setCurrentResearchMarkdownVersion(latestResearchVersion);
      setOriginalResearchMarkdownContent(
        response?.research?.[latestResearchVersion - 1]?.["markdown"]
      );
      showNotification("Research saved successfully", "success");
      setActiveStep(activeStep + 1);
    } catch (error) {
      console.log(error);
      showNotification("Research saving failed", "danger");
    } finally {
      setLoader({ show: false, type: "", message: "" });
    }
  };

  const onResearchSave = async () => {
    try {
      setLoader({
        show: true,
        type: "save",
        message: "Saving your research...",
      });
      const formData = new FormData();
      formData.append("case_study_id", caseStudyID);
      formData.append("researchMarkdown", researchMarkdown);
      const response = await saveResearchAPI(formData);
      setCaseStudyDetails(response);
      const latestResearchVersion =
        response?.research?.length > 0
          ? response?.research?.[response?.research?.length - 1]?.version
          : 1;
      setCurrentResearchMarkdownVersion(latestResearchVersion);
      setOriginalResearchMarkdownContent(
        response?.research?.[latestResearchVersion - 1]?.["markdown"]
      );
      setResearchMarkdown(
        response?.research?.[latestResearchVersion - 1]?.["markdown"]
      );
      showNotification("Research saved successfully", "success");
    } catch (error) {
      console.log(error);
      showNotification("Case study research saving failed", "danger");
    } finally {
      setLoader({ show: false, type: "", message: "" });
    }
  };

  useEffect(() => {
    setResearchMarkdown(
      caseStudyDetails?.["research"]?.[currentResearchMarkdownVersion - 1]?.[
        "markdown"
      ]
    );
    setOriginalResearchMarkdownContent(
      caseStudyDetails?.["research"]?.[currentResearchMarkdownVersion - 1]?.[
        "markdown"
      ]
    );
  }, [currentResearchMarkdownVersion]);

  useEffect(() => {
    setDraftMarkdown(
      caseStudyDetails?.["draft"]?.[currentDraftMarkdownVersion - 1]?.[
        "markdown"
      ]
    );
    setOriginalDraftMarkdownContent(
      caseStudyDetails?.["draft"]?.[currentDraftMarkdownVersion - 1]?.[
        "markdown"
      ]
    );
  }, [currentDraftMarkdownVersion]);

  useEffect(() => {
    setLabDetailsMarkdown(
      caseStudyDetails?.["lab_details"]?.[
        currentLabDetailsMarkdownVersion - 1
      ]?.["markdown"]
    );
    setOriginalLabDetailsMarkdownContent(
      caseStudyDetails?.["lab_details"]?.[
        currentLabDetailsMarkdownVersion - 1
      ]?.["markdown"]
    );
  }, [currentLabDetailsMarkdownVersion]);

  useEffect(() => {
    setTeachingNoteMarkdown(
      caseStudyDetails?.["teaching_note"]?.[
        currentTeachingNoteMarkdownVersion - 1
      ]?.["markdown"]
    );
    setOriginalTeachingNoteMarkdownContent(
      caseStudyDetails?.["teaching_note"]?.[
        currentTeachingNoteMarkdownVersion - 1
      ]?.["markdown"]
    );
  }, [currentTeachingNoteMarkdownVersion]);

  const onResearchNext = async () => {
    if (researchMarkdown !== originalResearchMarkdownContent)
      await onResearchSave();
    try {
      setLoader({
        show: true,
        type: "save",
        message:
          "Generating the case study for you. This might take a few seconds...",
      });
      const formData = new FormData();
      formData.append("case_study_id", caseStudyID);
      const response = await draftStepAPI(formData);
      const latestDraftVersion =
        response?.draft?.length > 0
          ? response?.draft?.[response?.draft?.length - 1]?.version
          : 1;
      setDraftMarkdown(response?.draft?.[latestDraftVersion - 1]?.["markdown"]);
      setOriginalDraftMarkdownContent(
        response?.draft?.[latestDraftVersion - 1]?.["markdown"]
      );
      setCurrentDraftMarkdownVersion(latestDraftVersion);

      if (response.has_teaching_note) {
        const latestTeachingNoteVersion =
          response?.teaching_note?.length > 0
            ? response?.teaching_note?.[response?.teaching_note?.length - 1]
                ?.version
            : 1;
        setTeachingNoteMarkdown(
          response?.teaching_note?.[latestTeachingNoteVersion - 1]?.["markdown"]
        );
        setOriginalTeachingNoteMarkdownContent(
          response?.teaching_note?.[latestTeachingNoteVersion - 1]?.["markdown"]
        );
        setCurrentTeachingNoteMarkdownVersion(latestTeachingNoteVersion);
      }
      if (response.has_lab_details) {
        const latestLabDetailsVersion =
          response?.lab_details?.length > 0
            ? response?.lab_details?.[response?.lab_details?.length - 1]
                ?.version
            : 1;
        setLabDetailsMarkdown(
          response?.lab_details?.[latestLabDetailsVersion - 1]?.["markdown"]
        );
        setOriginalLabDetailsMarkdownContent(
          response?.lab_details?.[latestLabDetailsVersion - 1]?.["markdown"]
        );
        setCurrentLabDetailsMarkdownVersion(latestLabDetailsVersion);
      }
      setCaseStudyDetails(response);
      setActiveStep(activeStep + 1);
      showNotification("Research saved successfully", "success");
    } catch (error) {
      console.log(error);
      showNotification("Research saving failed", "danger");
    } finally {
      setLoader({ show: false, type: "", message: "" });
    }
  };

  const onDraftSave = async () => {
    try {
      setLoader({
        show: true,
        type: "save",
        message: "Saving draft. This might take a few seconds...",
      });
      const formData = new FormData();
      formData.append("case_study_id", caseStudyID);
      formData.append("draftMarkdown", draftMarkdown);
      const response = await saveDraftAPI(formData);
      setCaseStudyDetails(response);
      const latestDraftVersion =
        response?.draft?.length > 0
          ? response?.draft?.[response?.draft?.length - 1]?.version
          : 1;
      setCurrentDraftMarkdownVersion(latestDraftVersion);
      setOriginalDraftMarkdownContent(
        response?.draft?.[latestDraftVersion - 1]?.["markdown"]
      );
      setDraftMarkdown(response?.draft?.[latestDraftVersion - 1]?.["markdown"]);
      showNotification("Draft saved successfully", "success");
    } catch (error) {
      console.log(error);
      showNotification("Draft saving failed", "danger");
    } finally {
      setLoader({ show: false, type: "", message: "" });
    }
  };

  const onDraftDownload = () => {
    const handleDownload = async () => {
      const formData = new FormData();
      formData.append("markdown_content", draftMarkdown);
      formData.append("project_id", caseStudyID);

      try {
        setLoader({
          show: true,
          type: "save",
          message: "Downloading draft. This might take a few seconds...",
        });
        const { blob, filename } = await convertToPdf(formData);
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download =
          caseStudyDetails?.name.replace(/\s/g, "_") + "_Draft.pdf";
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(url);
      } catch (err) {
        console.error(err);
      } finally {
        setLoader({ show: false, type: "", message: "" });
      }
    };
    handleDownload();
  };

  const onTeachingNoteSave = async () => {
    try {
      setLoader({
        show: true,
        type: "save",
        message: "Saving draft. This might take a few seconds...",
      });
      const formData = new FormData();
      formData.append("case_study_id", caseStudyID);
      formData.append("teachingNoteMarkdown", teachingNoteMarkdown);
      const response = await saveTeachingNoteAPI(formData);
      setCaseStudyDetails(response);
      const latestTeachingNoteVersion =
        response?.teaching_note?.length > 0
          ? response?.teaching_note?.[response?.teaching_note?.length - 1]
              ?.version
          : 1;
      setCurrentTeachingNoteMarkdownVersion(latestTeachingNoteVersion);
      setOriginalTeachingNoteMarkdownContent(
        response?.teaching_note?.[latestTeachingNoteVersion - 1]?.["markdown"]
      );
      setTeachingNoteMarkdown(
        response?.teaching_note?.[latestTeachingNoteVersion - 1]?.["markdown"]
      );
      showNotification("Teaching Note saved successfully", "success");
    } catch (error) {
      console.log(error);
      showNotification("Teaching Note saving failed", "danger");
    } finally {
      setLoader({ show: false, type: "", message: "" });
    }
  };

  const onTeachingNoteDownload = () => {
    const handleDownload = async () => {
      const formData = new FormData();
      formData.append("markdown_content", teachingNoteMarkdown);
      formData.append("project_id", caseStudyID);

      try {
        setLoader({
          show: true,
          type: "save",
          message: "Downloading draft. This might take a few seconds...",
        });
        const { blob, filename } = await convertToPdf(formData);
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download =
          caseStudyDetails?.name.replace(/\s/g, "_") + "_TeachingNote.pdf";
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(url);
      } catch (err) {
        console.error(err);
      } finally {
        setLoader({ show: false, type: "", message: "" });
      }
    };
    handleDownload();
  };

  const onLabDetailsSave = async () => {
    try {
      setLoader({
        show: true,
        type: "save",
        message: "Saving draft. This might take a few seconds...",
      });
      const formData = new FormData();
      formData.append("case_study_id", caseStudyID);
      formData.append("labDetailsMarkdown", labDetailsMarkdown);
      const response = await saveLabDetailsAPI(formData);
      setCaseStudyDetails(response);
      const latestLabDetailsVersion =
        response?.lab_details?.length > 0
          ? response?.lab_details?.[response?.lab_details?.length - 1]?.version
          : 1;
      setCurrentLabDetailsMarkdownVersion(latestLabDetailsVersion);
      setOriginalLabDetailsMarkdownContent(
        response?.lab_details?.[latestLabDetailsVersion - 1]?.["markdown"]
      );
      setLabDetailsMarkdown(
        response?.lab_details?.[latestLabDetailsVersion - 1]?.["markdown"]
      );
      showNotification("Lab Details saved successfully", "success");
    } catch (error) {
      console.log(error);
      showNotification("Lab Details saving failed", "danger");
    } finally {
      setLoader({ show: false, type: "", message: "" });
    }
  };

  const onLabDetailsDownload = () => {
    const handleDownload = async () => {
      const formData = new FormData();
      formData.append("markdown_content", labDetailsMarkdown);
      formData.append("project_id", caseStudyID);

      try {
        setLoader({
          show: true,
          type: "save",
          message: "Downloading draft. This might take a few seconds...",
        });
        const { blob, filename } = await convertToPdf(formData);
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download =
          caseStudyDetails?.name.replace(/\s/g, "_") + "_LabDetails.pdf";
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(url);
      } catch (err) {
        console.error(err);
      } finally {
        setLoader({ show: false, type: "", message: "" });
      }
    };
    handleDownload();
  };

  const tabs = useMemo(
    () => [
      {
        key: "draft",
        label: "Case Study",
        title: "Case Study Draft & Refinement",
        desc: "Produce and refine the HBS-style draft.",
        icon: <Print fontSize="small" />,
      },
      ...(caseStudyDetails?.has_teaching_note
        ? [
            {
              key: "teaching",
              label: "Teaching Note",
              title: "Teaching Note",
              desc: "Develop the HBS-style teaching note.",
              icon: <AssignmentInd fontSize="small" />,
            },
          ]
        : []),
      ...(caseStudyDetails?.has_lab_details
        ? [
            {
              key: "lab",
              label: "Lab",
              title: "Lab",
              desc: "Document the Streamlit lab extension.",
              icon: <Details fontSize="small" />,
            },
          ]
        : []),
    ],
    [caseStudyDetails?.has_teaching_note, caseStudyDetails?.has_lab_details]
  );
  const [activeTab, setActiveTab] = useState(tabs[0].key);

  const screens = {
    draft: (
      <ReviewScreen
        title="Case Draft & Refinement"
        description="Produce and refine the HBS-style draft."
        nextLabel="Download All"
        isMultiSelect={false}
        markdownContent={draftMarkdown}
        setMarkdownContent={setDraftMarkdown}
        versionOptions={caseStudyDetails.draft}
        version={currentDraftMarkdownVersion}
        setVersion={setCurrentDraftMarkdownVersion}
        onNext={() => {
          for (const tab of tabs) {
            if (tab.key === "lab") {
              onLabDetailsDownload();
            }
            if (tab.key === "teaching") {
              onTeachingNoteDownload();
            }
            if (tab.key === "draft") {
              onDraftDownload();
            }
          }
        }}
        onSave={onDraftSave}
        setLoading={setLoader}
        originalMarkdownContent={originalDraftMarkdownContent}
      />
    ),
    teaching: (
      <ReviewScreen
        title="Teaching Note"
        description="Instructor guidance and learning objectives."
        nextLabel="Download All"
        markdownContent={teachingNoteMarkdown}
        setMarkdownContent={setTeachingNoteMarkdown}
        versionOptions={caseStudyDetails.teaching_note}
        version={currentTeachingNoteMarkdownVersion}
        setVersion={setCurrentTeachingNoteMarkdownVersion}
        onNext={() => {
          for (const tab of tabs) {
            if (tab.key === "lab") {
              onLabDetailsDownload();
            }
            if (tab.key === "teaching") {
              onTeachingNoteDownload();
            }
            if (tab.key === "draft") {
              onDraftDownload();
            }
          }
        }}
        onSave={onTeachingNoteSave}
        setLoading={setLoader}
        originalMarkdownContent={originalTeachingNoteMarkdownContent}
      />
    ),
    lab: (
      <ReviewScreen
        title="Lab Appendix"
        description="Streamlit lab integration details."
        nextLabel="Download All"
        markdownContent={labDetailsMarkdown}
        setMarkdownContent={setLabDetailsMarkdown}
        versionOptions={caseStudyDetails.lab_details}
        version={currentLabDetailsMarkdownVersion}
        setVersion={setCurrentLabDetailsMarkdownVersion}
        onNext={() => {
          for (const tab of tabs) {
            if (tab.key === "lab") {
              onLabDetailsDownload();
            }
            if (tab.key === "teaching") {
              onTeachingNoteDownload();
            }
            if (tab.key === "draft") {
              onDraftDownload();
            }
          }
        }}
        onSave={onLabDetailsSave}
        setLoading={setLoader}
        originalMarkdownContent={originalLabDetailsMarkdownContent}
      />
    ),
  };

  const renderContent = () => {
    const stepLabel = caseStudySteps[activeStep]?.label;
    if (!stepLabel) return <></>;

    switch (stepLabel) {
      case "Details":
        return (
          <ProjectDetails
            caseStudyID={caseStudyID}
            caseStudy={caseStudyDetails}
            loading={loader.show}
            associatedProjects={projects}
            setActiveStep={setActiveStep}
            onSave={onDetailsSave}
            onNext={onDetailsNext}
            setFileList={setFileList}
            fileList={fileList}
          />
        );
      case "Background":
        return (
          <Background
            caseStudyID={caseStudyID}
            caseStudy={caseStudyDetails}
            loading={loader.show}
            setActiveStep={setActiveStep}
            onSave={onBackgroundSave}
            onNext={onBackgroundNext}
            caseStudyDetails={caseStudyDetails}
            setCaseStudyDetails={setCaseStudyDetails}
          />
        );
      case "Ideation":
        return (
          <Ideation
            caseStudyID={caseStudyID}
            caseStudy={caseStudyDetails}
            loading={loader.show}
            setActiveStep={setActiveStep}
            onSave={onIdeationSave}
            onNext={onIdeationNext}
            caseStudyDetails={caseStudyDetails}
            setCaseStudyDetails={setCaseStudyDetails}
          />
        );
      case "Research":
        return (
          <ReviewScreen
            title="Research Curation"
            description="Select and organize sources and exhibits, validate credibility and coverage, and tailor materials to the narrative and outcomes."
            nextLabel="Next"
            dropdown_label=""
            dropdown_options={null}
            onDropDownSelection={null}
            isMultiSelect={false}
            markdownContent={researchMarkdown}
            setMarkdownContent={setResearchMarkdown}
            versionOptions={caseStudyDetails.research}
            version={currentResearchMarkdownVersion}
            setVersion={setCurrentResearchMarkdownVersion}
            onNext={onResearchNext}
            onSave={onResearchSave}
            setLoading={setLoader}
            originalMarkdownContent={originalResearchMarkdownContent}
          />
        );
      case "Draft":
        return (
          <div>
            <div
              style={{
                display: "flex",
                gap: 8,
                borderBottom: "1px solid #e5e7eb",
                marginBottom: 12,
              }}
            >
              {tabs.map((t) => (
                <button
                  key={t.key}
                  onClick={() => setActiveTab(t.key)}
                  style={{
                    padding: "8px 12px",
                    border: "none",
                    borderBottom:
                      activeTab === t.key
                        ? "2px solid #1a5f7a"
                        : "2px solid transparent",
                    background: "transparent",
                    color: activeTab === t.key ? "#1a5f7a" : "#374151",
                    fontWeight: activeTab === t.key ? 600 : 500,
                    cursor: "pointer",
                    // align items vertically
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                  }}
                >
                  {t.icon}
                  {t.label}
                </button>
              ))}
            </div>
            {screens[activeTab]}
          </div>
        );
      default:
        return <></>;
    }
  };

  if (loader.show) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="60vh"
      >
        <CircularProgress className={classes.loaderClass} />
        <Typography
          variant="h6"
          style={{ marginLeft: 16, textTransform: "none" }}
        >
          {loader.message}
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      <AppBar position="static" className={classes.header}>
        <Toolbar>
          <Box
            display="flex"
            justifyContent="space-between"
            width="100%"
            alignItems="center"
          >
            <Typography
              variant="h5"
              style={{
                color: "black",
                fontWeight: "bold",
                flexShrink: 0,
                maxWidth: "45%",
                wordBreak: "break-word",
                overflow: "hidden",
                whiteSpace: "normal",
              }}
            >
              {caseStudyDetails.name}
            </Typography>

            <Stepper
              activeStep={visualActiveStep}
              alternativeLabel
              connector={<QontoConnector />}
              size="small"
              className={classes.stepperRoot}
              style={{ flexGrow: 1 }}
            >
              {stepsWithIntermediate.map((step, index) => {
                const isIntermediate = !!step.isIntermediate;
                const isDisabled = isIntermediate
                  ? false // allow clicking the loading bubble to restore content loader
                  : index >
                    (stepperInBetween
                      ? caseStudyCompletedTillStep + 1
                      : caseStudyCompletedTillStep);

                return (
                  <Step
                    key={`${step.label}-${index}`}
                    onClick={() => handleStepClick(index)}
                  >
                    <StepLabel
                      StepIconComponent={
                        isIntermediate ? <CircularProgress /> : undefined
                      }
                      StepIconProps={
                        !isIntermediate && !isDisabled
                          ? {
                              classes: {
                                root: classes.stepIcon,
                                active: classes.activeStepIcon,
                                completed: classes.completedStepIcon,
                              },
                            }
                          : {}
                      }
                    >
                      {caseStudyStatusToLabelMapping[step.label]}
                    </StepLabel>
                  </Step>
                );
              })}
            </Stepper>
          </Box>
        </Toolbar>
      </AppBar>

      <Box mt={3}>{renderContent()}</Box>
    </Box>
  );
};
